<template>
  <div id="container" class="-m-[20px]"></div>
  <!-- <div
    class="w-full h-full flex-y-center justify-center gap-[20px] px-[20px] relative"
  >
    <div class="flex flex-col gap-[20px]">
      <div
        v-for="(item, index) in result"
        :key="index"
        class="flex flex-wrap text-12 min-w-[160px]"
      >
        <span>
          <a-progress
            :strokeColor="item.color"
            type="circle"
            :percent="100"
            :size="12"
          />
          <span class="text-font-60 ml-[5px]">{{ item.name }}：</span>
        </span>
        <span>{{ item.remain }} / {{ item.total }}</span>
      </div>
    </div>
    <div id="container"></div>
  </div> -->
</template>

<script setup lang="ts" name="CoinChart">
import { Runtime, extend, corelib } from '@antv/g2'

const Chart = extend(Runtime, corelib())

const props = defineProps<{ data: any }>()
const initChart = () => {
  const chart = new Chart({ container: 'container' })

  chart.options({
    type: 'view',
    width: 180,
    height: 180,
    data: props.data,
    coordinate: { type: 'radial', innerRadius: 0.1 },
    children: [
      {
        type: 'interval',
        encode: { x: 'name', y: 1, size: 30, color: 'color' },
        scale: { color: { type: 'identity' } },
        style: { fillOpacity: 0.2 },
        animate: false,
        tooltip: false,
      },
      {
        type: 'interval',
        encode: { x: 'name', y: 'percent', color: 'color', size: 30 },
        style: {
          radius: 26,
        },
        animate: {
          enter: {
            type: 'waveIn',
            easing: 'easing-out-bounce',
            duration: 1000,
          },
        },
        axis: false,
        tooltip: {
          title: 'expired',
          items: [
            (data) => ({
              name: data.name,
              value: `${data.remain}/${data.total}`,
              field: 'expired',
            }),
          ],
        },
      },
    ],
  })

  chart.render()
}

if (import.meta.client) {
  watch(
    () => props.data,
    (cur, bef) => {
      if (cur !== bef) {
        nextTick(() => {
          initChart()
        })
      }
    },
    { immediate: true }
  )
}
</script>
